import { APP_SLUG } from '@models/AppType'
import { SurveyStep } from '@models/Survey/SurveyStep'
import { surveyStorage } from '@plugins/storage'

const SLUG_OVERRIDE_KEY = 'debug:slug:override'

const isLocalDevHost = (): boolean => {
  const { hostname, port } = window.location
  if (port === '3000' || port === '5173') {
    return true
  }
  return hostname === 'localhost' || hostname === ''
}

/** Même critère que le bouton « Continuer le questionnaire » sur l’accueil. */
export function isSurveyInProgress(step: SurveyStep, hasConsented: boolean): boolean {
  return hasConsented && step !== SurveyStep.Sandbox
}

export async function switchEdition(accessSlug: string): Promise<void> {
  if (accessSlug === APP_SLUG) {
    window.location.href = '/'
    return
  }

  await surveyStorage.clear()

  if (isLocalDevHost()) {
    localStorage.setItem(SLUG_OVERRIDE_KEY, accessSlug)
    window.location.href = '/'
    return
  }

  const baseHostname = (import.meta.env.VITE_APP_BASE_HOSTNAME as string) ?? 'datagotchi.com'
  window.location.assign(`https://${accessSlug}.${baseHostname}/`)
}
